<template>
  <div>
    <tk-flex between style="align-items: stretch;">
      <tk-flex>
        <DateSelect v-bind='$attrs' v-on="$listeners" v-show="pageType === 'summary' || pageType === 'report'" />
        <a-select v-model="time" style="width: 120px; margin-left: 15px;"
          v-show="pageType === 'summary' || pageType === 'report'">
          <a-select-option v-for="item in allTimes" :key="item" :value="item">
            {{ item }}
          </a-select-option>
        </a-select>
      </tk-flex>
      <tk-flex middle>
        <router-link :to="{
          path: '/grainstore/detail',
          query: { store: storeId, type: 'summary' }
        }">
          <a-button :type="pageType == 'summary' ? 'primary' : 'default'" class="m-r-10">汇总</a-button>
        </router-link>
        <router-link :to="{
          path: '/grainstore/detail',
          query: { store: storeId, type: 'report' }
        }">
          <a-button :type="pageType == 'report' ? 'primary' : 'default'" class="m-r-10">报表</a-button>
        </router-link>
        <router-link :to="{
          path: '/grainstore/detail',
          query: { store: storeId, type: 'curve' }
        }">
          <a-button :type="pageType == 'curve' ? 'primary' : 'default'" class="m-r-10">曲线</a-button>
        </router-link>
        <router-link :to="{
          path: '/grainstore/detail',
          query: { store: storeId, type: 'compared' }
        }">
          <a-button :type="pageType == 'compared' ? 'primary' : 'default'" class="m-r-10">数据对比</a-button>
        </router-link>
        <a-button @click="visibleWatch = true">摄像头</a-button>
        <tk-flex class="m-l-10" middle>
          <svg style="cursor: pointer;" @click="showEditStrore = true" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="12.008522987365723"
            height="12.000001907348633" viewBox="0 0 12.008522987365723 12.000001907348633">
            <g>
              <path
                d="M5.33333,0C5.70152,0,6,0.298477,6,0.666667C6,1.03486,5.70152,1.33333,5.33333,1.33333L1.33333,1.33333L1.33333,10.6667L10.6667,10.6667L10.6667,6.66667L10.6713,6.58867C10.713,6.23841,11.0203,5.98121,11.3724,6.00188C11.7245,6.02256,11.9996,6.31394,12,6.66667L12,10.6667C12,11.403,11.403,12,10.6667,12L1.33333,12C0.596954,12,1.52588e-7,11.403,0,10.6667L0,1.33333C0,0.596954,0.596954,3.05176e-7,1.33333,1.52588e-7L5.33333,0ZM11.8133,0.195333C12.0736,0.455666,12.0736,0.877666,11.8133,1.138L5.68533,7.26667C5.42375,7.51931,5.00795,7.51569,4.7508,7.25854C4.49364,7.00138,4.49003,6.58559,4.74267,6.324L10.8707,0.196C11.131,-0.064254,11.553,-0.064254,11.8133,0.196L11.8133,0.195333Z"
                fill="#2FBF79" fill-opacity="1" />
            </g>
          </svg>
          <span class="m-l-5" style="cursor: pointer;color: #2FBF79; font-size: 14px;"
            @click="showEditStrore = true">编辑仓房信息</span>
        </tk-flex>
      </tk-flex>

    </tk-flex>
    <a-modal :maskClosable="false" class="hiddle-footer" title="摄像头" :width="watchWidth" @cancel="visibleWatch = false"
      :visible="visibleWatch" destroyOnClose centered :footer="null">
      <tk-flex between>
        <a-button-group>
          <a-button v-for="(item, index) in equipments" :key="item.objectId"
            :type="currentIndex === index ? 'primary' : 'default'" @click="currentIndex = index">摄像头{{ index + 1
            }}</a-button>
        </a-button-group>
        <a-button type="primary" @click="showEdit(false)" v-if="can('createCamera')">
          新增
        </a-button>
      </tk-flex>
      <div v-if="equipments.length > 0">
        <div v-for="(item, index) in equipments" :key="item.objectId" v-show="currentIndex === index">
          <div class="m-t-20 full-width rounded-xl" style="background-color: #eee;"
            :style="{ height: watchWidth * 0.35 + 'px' }">
            <Camera v-if="currentIndex === index" :info="item" ref="camera" />
          </div>
          <tk-flex right class="m-t-20">
            <a-button class="m-r-10" @click="editEq(index)" v-if="can('editCamera')">编辑</a-button>
            <a-button class="m-r-10" v-if="can('deleteCamera')" @click="deletes(index)">删除</a-button>
            <a-popover trigger="click" placement="right">
              <template slot="content">
                <ControlPanel @left="left" @top="top" @right="right" @bottom="bottom" @stopMove="stopMove"
                  @zoomIn="zoomIn" @zoomOut="zoomOut" @stopZoom="stopZoom" />
              </template>
              <a-button type="primary">调整角度</a-button>
            </a-popover>
          </tk-flex>
        </div>
      </div>
      <div style="height: 200" v-else>
        <a-empty></a-empty>
      </div>
    </a-modal>
    <a-modal :maskClosable="false" :title="editTitle" :width="editWidth" @cancel="visibleEdit = false"
      :visible="visibleEdit" destroyOnClose centered @ok="handleEditOk">
      <EquipmentEidt v-if="!loading" :allEq="equipments" :cameraLength="cameraLength" :setting="editEqinfo"
        :storeId="storeId" :horizontal="width" :vertical="height" :height="storeInfo.height" ref="eq" :isCircle="isCircle"
        :diameter="isCircle ? storeInfo.diameter : 0" @updateEq="updateEq" />
    </a-modal>
    <a-modal :maskClosable="false" :title="`确定要删除“${deleteItem ? deleteItem.name : ''}”吗？`" :visible="showDele"
      destroyOnClose :confirm-loading="confirmDeleLoading" @ok="handleDeleOk" @cancel="handleDeleCancel">
      <p>删除此摄像头将无法恢复，您要继续吗？</p>
    </a-modal>
    <a-modal :maskClosable="false" title="编辑粮仓" :visible="showEditStrore" :confirm-loading="confirmEditLoading"
      @ok="handleEditStoreOk" destroyOnClose @cancel="handleEditCancel">
      <ak-type-input ref="name" key="name" v-model="formdata.name" :field="options[0]" style="width: 100%" />
      <ak-type-input ref="expectation" key="expectation" v-model="formdata.expectation" :field="options[1]"
        style="width: 100%" />
      <ak-type-input ref="reality" key="reality" v-model="formdata.reality" :field="options[2]" style="width: 100%" />
      <ak-type-input ref="type" key="type" v-model="formdata.type" :field="options[3]" style="width: 100%" />
      <ak-type-input ref="subtype" key="subtype" v-if="formdata.type == 'square'" v-model="formdata.subtype"
        :field="options[4]" style="width: 100%" />
      <ak-type-input ref="subtype2" key="subtype2" v-if="formdata.type == 'circle'" v-model="formdata.subtype"
        :field="options[5]" style="width: 100%" />
      <ak-type-input ref="length" key="length" v-if="formdata.type == 'square'" v-model="formdata.length"
        :field="options[6]" style="width: 100%" />
      <ak-type-input ref="width" key="width" v-if="formdata.type == 'square'" v-model="formdata.width" :field="options[7]"
        style="width: 100%" />
      <ak-type-input ref="height" key="height" v-if="formdata.type" v-model="formdata.height" :field="options[8]"
        style="width: 100%" />
      <ak-type-input ref="diameter" key="diameter" v-if="formdata.type == 'circle'" v-model="formdata.diameter"
        :field="options[9]" style="width: 100%" />
      <!-- <ak-type-input
        ref="grainType"
        key="grainType"
        v-model="formdata.grainType"
        :field="options[10]"
        style="width: 100%"
      />
      <ak-type-input
        ref="storageType"
        key="storageType"
        v-model="formdata.storageType"
        :field="options[11]"
        style="width: 100%"
      /> -->
      <ak-type-input ref="incomeAt" key="incomeAt" v-model="formdata.incomeAt" :field="options[12]" style="width: 100%" />
      <ak-type-input ref="leaveAt" key="leaveAt" v-model="formdata.leaveAt" :field="options[13]" style="width: 100%" />
      <a-form-model ref="form" :model="formdata" :rules="{
        times: [{ validator: validateTimes, trigger: 'change' }]
      }">
        <a-form-model-item ref="times" label="定时拍摄" prop="times">
          <tk-flex style="width: 100%" v-for="(item, index) in formdata.times" :key="item + index" class="m-b-10">
            <a-time-picker :disabled="!canEdit" style="flex-grow: 1" class="flex-grow m-r-10" format="HH:mm"
              valueFormat="HH:mm" v-model="formdata.times[index]" />
            <a-button v-if="index === formdata.times.length - 1" @click="addTimes" :disabled="!canEdit"><tk-flex
                middle><a-icon type="plus" :style="{ fontSize: '14px' }" /></tk-flex></a-button>
            <a-button v-else @click="deleteTimes(index)" :disabled="!canEdit"><tk-flex middle><a-icon type="minus"
                  :style="{ fontSize: '14px' }" /></tk-flex></a-button>
          </tk-flex>
        </a-form-model-item>
      </a-form-model>
      <ak-type-input ref="custodianUser" key="custodianUser" v-model="formdata.custodianUser" :field="options[14]"
        style="width: 100%" />
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment'
import EquipmentEidt from './equipment'
import Camera from './camera/camera'
import ControlPanel from './camera/controlPanel'
import DateSelect from './dateSelect'
import { notEmpty } from '../../utils/validator'
import { formatCompact, formatTimeShow } from '../../utils/format.js'
import multipleTime from '../../assets/js/multipleTime'
const squareRoot2 = 1.414
export default {
  name: 'StorePageSwicth',
  mixins: [
    multipleTime
  ],
  components: {
    EquipmentEidt,
    Camera,
    ControlPanel,
    DateSelect
  },
  model: {
    prop: 'currentTime',
    event: 'change'
  },
  props: {
    equipments: {
      type: Array,
      required: true
    },
    storeInfo: {
      type: Object,
      required: true
    },
    currentTimeTag: {
      type: String,
      default: ''
    },
    // currentTime: {
    //   type: Object,
    //   required: true
    // },
    allTimes: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      // year: this.currentTime.year(),
      // month: this.currentTime.month() + 1,
      // day: this.currentTime.date(),
      years: [],
      months: [],
      days: [],
      cameraLength: 0,
      editTitle: '',
      watchWidth: 0,
      editWidth: 0,
      visibleWatch: false,
      visibleEdit: false,
      showDele: false,
      confirmDeleLoading: false,
      editEqinfo: null,
      currentIndex: 0,
      deleteItem: null,
      // edit modal
      showEditStrore: false,
      formdata: {},
      options: [
        {
          name: 'name',
          note: '粮仓名称',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'expectation',
          note: '设计储量(kg)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'reality',
          note: '实际储量(kg)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'type',
          note: '仓房类型',
          type: 'Select',
          validators: [notEmpty()],
          items: {
            square: '方仓',
            circle: '圆仓'
          }
        },
        {
          name: 'subtype',
          note: '方仓类型',
          type: 'Select',
          validators: [notEmpty()],
          items: {
            bungalow: '平房仓',
            otherSquare: '其他方仓'
          }
        },
        {
          name: 'subtype1',
          note: '圆仓类型',
          type: 'Select',
          validators: [notEmpty()],
          items: {
            shallow: '浅圆仓',
            bamboo: '筒仓',
            otherCircle: '其他圆仓'
          }
        },
        {
          name: 'length',
          note: '粮仓长度(米)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'width',
          note: '粮仓宽度(米)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'height',
          note: '粮面高度(米)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'diameter',
          note: '粮仓直径(米)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'grainType',
          note: '粮食品种',
          type: 'Select',
          validators: [notEmpty()],
          items: {}
        },
        {
          name: 'storageType',
          note: '储量性质',
          type: 'Select',
          validators: [notEmpty()],
          items: {}
        },
        {
          name: 'incomeAt',
          note: '入仓时间',
          type: 'Date',
          span: 24,
          validators: [notEmpty()]
        },
        {
          name: 'leaveAt',
          note: '计划出仓时间',
          type: 'Date',
          span: 24,
          validators: []
        },
        {
          name: 'custodianUser',
          note: '保管员',
          type: 'String',
          validators: [notEmpty()]
        }
      ],
      confirmEditLoading: false,
      canEdit: true
    }
  },
  watch: {
    year (newV) {
      this.months = []
      this.month = ''
      if (newV) {
        this.getAllMonths()
      }
    },
    month (newV) {
      this.days = []
      this.day = ''
      if (newV) {
        this.getAllDays()
      }
    },
    day (newV) {
      if (newV) {
        this.$emit(
          'change',
          moment()
            .year(Number(this.year))
            .month(Number(this.month) - 1)
            .date(Number(this.day))
        )
      }
    }
  },
  computed: {
    time: {
      get () {
        return this.currentTimeTag
      },
      set (val) {
        this.$emit('update:currentTimeTag', val)
      }
    },
    pageType () {
      return this.$route.query.type
    },
    storeId () {
      return this.$route.query.store
    },
    loading () {
      return Object.keys(this.storeInfo).length === 0
    },
    width () {
      if (this.storeInfo.type === 'square') {
        return this.storeInfo.length
      } else if (this.storeInfo.type === 'circle') {
        return this.storeInfo.diameter / squareRoot2
      } else {
        return 0
      }
    },
    height () {
      if (this.storeInfo.type === 'square') {
        return this.storeInfo.width
      } else if (this.storeInfo.type === 'circle') {
        return this.storeInfo.diameter / squareRoot2
      } else {
        return 0
      }
    },
    isCircle () {
      return this.storeInfo.type !== 'square'
    }
  },
  mounted () {
    this.watchWidth = window.outerWidth * 0.6
    this.editWidth = window.outerWidth * 0.7
    this.getCameraLength()
    this.getStroeInfo()
    // this.getAllTimesSelect()
  },
  methods: {
    formatCompact,
    formatTimeShow,
    async handleEditStoreOk () {
      const flag = await this.validate()
      if (flag) {
        const times = this.formatTimes()
        this.confirmEditLoading = true
        await this.$tkParse.put(
          `/classes/grainStorehouse/${this.storeId}`,
          {
            name: this.formdata.name,
            expectation: this.formdata.expectation,
            reality: this.formdata.reality,
            type: this.formdata.type,
            subtype: this.formdata.subtype,
            length: this.formdata.length,
            width: this.formdata.width,
            height: this.formdata.height,
            diameter: this.formdata.diameter,
            // grainType: this.formdata.grainType,
            // storageType: this.formdata.storageType,
            incomeAt: this.formdata.incomeAt,
            leaveAt: this.formdata.leaveAt,
            times: times,
            custodianUser: this.formdata.custodianUser
          }
        )
        this.showEditStrore = false
        this.confirmEditLoading = false
        // this.$emit('edit')
        window.location.reload()
      }
    },
    handleEditCancel () {
      this.showEditStrore = false
    },
    addTimes () {
      this.formdata.times.push('')
    },
    deleteTimes (index) {
      this.formdata.times.splice(index, 1)
    },
    async validate () {
      const ret = []
      const refskey = Object.keys(this.$refs)
      for (let index = 0; index < refskey.length; index++) {
        const element = refskey[index]
        const node = this.$refs[element]
        let canValidate = false
        if (node) {
          if (Array.isArray(node)) {
            canValidate = node.length > 0
          } else {
            canValidate = true
          }
        } else {
          canValidate = false
        }
        if (canValidate) {
          let item
          try {
            item = await this.$refs[element].validate()
          } catch (e) {
            item = e
          }
          if (item === true) {
            ret.push('')
          } else if (item === false) {
            ret.push('error')
          } else {
            ret.push(item)
          }
        }
      }
      const errors = ret.filter(element => element)
      if (errors.length > 0) {
        return false
      } else {
        const ret = this.checkTimeIntervals(this.sortUniq(this.formdata.times).filter(item => item))
        if (!ret) {
          this.$notification['error']({
            message: '定时设置',
            description: '设置的时间间隔需要在1小时以上，请检查设置的定时设置'
          })
        }
        return ret
      }
    },
    validateTimes (rule, value, callback) {
      if (this.formdata.times.some(item => item)) callback()
      else callback(new Error('请选择定时拍照时间'))
    },
    transformItems (list) {
      const json = {}
      list.forEach(element => {
        json[element.objectId] = element.name
      })
      return json
    },
    formatTimes () {
      const newTimes = this.sortUniq(this.formdata.times)
      if (newTimes.length !== this.formdata.times.length) {
        this.$notification['info']({
          message: '定时设置',
          description: '时间相同的设置只会保存一个'
        })
      }
      return newTimes.filter(item => item).join('@')
    },
    initFormData () {
      const data = {
        ...this.oldFormData
      }
      data.times = (data.times || '').split('@')
      return data
    },
    async getStroeInfo () {
      const res = await this.$tkParse.get(`/classes/grainStorehouse/${this.storeId}`)
      this.oldFormData = res.data
      this.formdata = this.initFormData()
    },
    getAllTimesSelect () {
      this.initTime()
      this.getAllYears()
      this.getAllMonths()
      this.getAllDays()
    },
    initTime () {
      this.days = [this.currentTime.date()]
      this.months = [this.currentTime.month() + 1]
      this.years = [this.currentTime.year()]
    },
    async getAllYears () {
      const res = await this.$tkParse.get('/aggregate/dayEq', {
        params: {
          group: {
            objectId: {
              arr: { $year: '$date' }
            }, // 用来分组的字段，留空代表不分组
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: 1 // 字段名前加$表示一个字段,这里将统计所有该字段的总和
            }
          },
          match: {
            grainstore: this.storeId
          } // 查询条件
        }
      })
      this.years = res.data.results
        .map(item => item.objectId.arr)
        .sort((a, b) => a - b)
    },
    async getAllMonths () {
      const res = await this.$tkParse.get('/aggregate/dayEq', {
        params: {
          group: {
            objectId: {
              arr: { $month: '$date' }
            }, // 用来分组的字段，留空代表不分组
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: 1 // 字段名前加$表示一个字段,这里将统计所有该字段的总和
            }
          },
          match: {
            date: {
              $gte: moment()
                .year(Number(this.year))
                .startOf('year')
                .toISOString(),
              $lt: moment()
                .year(Number(this.year))
                .endOf('year')
                .toISOString()
            }
          } // 查询条件
        }
      })
      this.months = res.data.results
        .map(item => item.objectId.arr)
        .sort((a, b) => a - b)
    },
    async getAllDays () {
      const res = await this.$tkParse.get('/aggregate/dayEq', {
        params: {
          group: {
            objectId: {
              arr: { $dayOfMonth: '$date' }
            }, // 用来分组的字段，留空代表不分组
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: 1 // 字段名前加$表示一个字段,这里将统计所有该字段的总和
            }
          },
          match: {
            date: {
              $gte: moment()
                .year(Number(this.year))
                .month(Number(this.month) - 1)
                .startOf('month')
                .toISOString(),
              $lt: moment()
                .year(Number(this.year))
                .month(Number(this.month) - 1)
                .endOf('month')
                .toISOString()
            }
          } // 查询条件
        }
      })
      this.days = res.data.results
        .map(item => item.objectId.arr)
        .sort((a, b) => a - b)
    },
    async getCameraLength () {
      // const res = await this.$tkParse.get('/settings/cameraLength')
      // const num = res.data
      this.cameraLength = 15 // Number.parseFloat(num)
    },
    handleDeleCancel () {
      this.deleteItem = null
      this.showDele = false
    },
    async handleDeleOk () {
      this.confirmDeleLoading = true
      this.$loading.show()
      await this.$tkParse.delete(
        `/classes/equipment/${this.deleteItem.objectId}`
      )
      this.currentIndex = 0
      this.$emit('updateEq')
      this.$loading.hide()
      this.confirmDeleLoading = false
      this.deleteItem = null
      this.showDele = false
    },
    async deletes (index) {
      this.deleteItem = this.equipments[index]
      this.showDele = true
    },
    left () {
      this.$refs.camera[0].move('left')
    },
    top () {
      this.$refs.camera[0].move('top')
    },
    right () {
      this.$refs.camera[0].move('right')
    },
    bottom () {
      this.$refs.camera[0].move('bottom')
    },
    stopMove () {
      this.$refs.camera[0].stopMove()
    },
    zoomIn () {
      this.$refs.camera[0].zoomIn()
    },
    zoomOut () {
      this.$refs.camera[0].zoomOut()
    },
    stopZoom () {
      this.$refs.camera[0].stopZoom()
    },
    editEq (index) {
      this.editEqinfo = this.equipments[index]
      this.showEdit(true)
    },
    updateEq () {
      this.$emit('updateEq')
      this.visibleEdit = false
    },
    showEdit (isEdit) {
      this.visibleWatch = false
      if (isEdit) {
        this.editTitle = '编辑摄像头'
        this.visibleEdit = true
      } else {
        this.editEqinfo = null
        this.editTitle = '新增摄像头'
        this.visibleEdit = true
      }
    },
    handleEditOk () {
      this.$refs.eq.save()
    }
  }
}
</script>
<style scoped>
::v-deep .hiddle-footer .ant-modal-footer {
  display: none;
}

.card-tag {
  color: #94979c;
  background: #dde0e5;
  font-size: 12px;
  margin-left: 5px;
  border-radius: 3px;
  padding: 0px 3px;
}

::v-deep .ant-calendar-picker {
  width: 100%;
}
</style>
